import React from 'react';

export const pricingFaqsData = [
  {
    title: "What if I don't like my voice?",
    content: (
      <>
        <p>The quality of your voice depends on the quality of your training data.</p>
        <p>If you are not satisfied with your voice, you can reach out to support for feedback on your dataset and a re-do if needed. We're here to help!</p>
      </>
    ),
  },
];
